import { MenuItem, menuItemTemplate as template } from '@microsoft/fast-foundation';
import { InternalNavigationRailItemComponent } from './InternalNavigationRailItem';
import styles from '../NavigationRailItem/NavigationRailItem.styles.scss';
export const internalNavigationRailItemDefinition = {
    baseName: 'internal-navigation-rail-item',
    baseClass: MenuItem,
    template: template,
    styles,
};
export const chameleonInternalNavigationRailItem = InternalNavigationRailItemComponent.compose(internalNavigationRailItemDefinition);
